import React, { useState } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import PsychologyIcon from "@mui/icons-material/Psychology";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

const GenratorModel = ({ isOpen, setIsOpen }) => {
  const [activeButton, setActiveButton] = useState(null); // To track active button

  const onCloseModal = () => setIsOpen(false);

  // Button data
  const buttonGroups = [
    { id: "openai", label: "OpenAI", icon: <PsychologyIcon className="icons-crm" /> },
    { id: "stablediffusion", label: "Stable Diffusion", icon: <AutoAwesomeIcon className="icons-crm" /> },
  ];

  const resolutionButtons = ["256x256", "512x512", "1024x1024"];
  const styleButtons = ["3d-model", "analog-film", "anime", "cinematic"];

  return (
    <Modal open={isOpen} onClose={onCloseModal} center>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-semibold text-gray-900">Generate new</h2>
      </div>

      <div className="space-y-6">
        <div>
          <input
            type="text"
            placeholder="Model name"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none "
          />
        </div>

        {/* Main Button Group */}
        <div className="flex gap-3">
          {buttonGroups.map((button) => (
            <button
              key={button.id}
              onClick={() => setActiveButton(button.id)}
              className={`px-4 py-2 rounded-full flex items-center gap-[2px] ${
                activeButton === button.id
                  ? "bg-[#27004a] text-white"
                  : "bg-gray-100 hover:bg-gray-200"
              }`}
            >
              <span>{button.icon}</span>
              {button.label}
            </button>
          ))}
        </div>

        <div>
          <textarea
            placeholder="Prompt"
            className="w-full px-3 py-2 border border-[#dbdbdb] rounded-md h-24 focus:outline-none"
          ></textarea>
        </div>

        {/* Image Resolution Buttons */}
        <div>
          <p className="text-sm font-medium text-gray-700 mb-2">Image resolution</p>
          <div className="flex gap-3">
            {resolutionButtons.map((res) => (
              <button
                key={res}
                onClick={() => setActiveButton(res)}
                className={`px-4 py-2 rounded-full ${
                  activeButton === res
                    ? "bg-[#27004a] text-white"
                    : "bg-gray-100 hover:bg-gray-200"
                }`}
              >
                {res}
              </button>
            ))}
          </div>
        </div>

        {/* Image Style Buttons */}
        <div>
          <p className="text-sm font-medium text-gray-700 mb-2">Image style</p>
          <div className="flex flex-wrap gap-3">
            {styleButtons.map((style) => (
              <button
                key={style}
                onClick={() => setActiveButton(style)}
                className={`px-4 py-2 rounded-full ${
                  activeButton === style
                    ? "bg-[#27004a] text-white"
                    : "bg-gray-100 hover:bg-gray-200"
                }`}
              >
                {style}
              </button>
            ))}
          </div>
        </div>

        {/* Generate Button */}
        <button className="w-full second-btn">Generate Image</button>
      </div>
    </Modal>
  );
};

export default GenratorModel;
